Vue.component('MpCardCores', {
    props: {
        value: {
            type: Number,
            default: function () {
                return 0;
            }
        },
        variation: {
            type: Number,
            default: function () {
                return 0;
            }
        },
        showVariation: {
            type: Boolean,
            default: true
        }
    },

    data: function() {
        return {

        };
    },

    computed: {

    },

    methods: {

    },

    mounted: function() {

    },

    template: `
    <div class="card-cores">
        <div class="card-cores__header">
            <span class="card-cores__label">
                <slot name="label"></slot>
            </span>
            <span class="card-cores__note">
                <slot name="note"></slot>
            </span>
        </div>
        <div class="card-cores__value">
            <span>{{value}}</span>
            <span class="card-cores__value-unit">
                <slot name="unit"></slot>
            </span>
        </div>
        <span class="card-cores__variation" :class="{'card-cores__variation--up': variation > 0, 'card-cores__variation--down': variation < 0}" v-if="showVariation">
            {{variation | formatVariation(2)}}%
        </span>
    </div>`,
});


